import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import globalLocale from 'element-ui/lib/locale'
// 引入中文包
import langZh from 'element-ui/lib/locale/lang/zh-CN'
// 引入英文包
import langEn from 'element-ui/lib/locale/lang/en'

import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import moment from 'moment';
import validate from '@/utils/validate'
import { getToken } from '@/api/auth'
import { getProfile } from '@/api/user'
import "@/assets/font/iconfont.css";
// 引入消息通知图标样式
import "@/assets/font/message-iconfont.css";
import { getLanguageList } from '@/api/lang'
import i18n from './lang'

Vue.prototype.$axios = axios
import * as echarts from 'echarts';
Vue.prototype.echarts = echarts;
import './theme/index.css'
import './theme/ccx.css'

import { isEmpty, isArray, isNumber, autoWrap, 
          hasClass, addClass, removeClass, 
          debounce, parseDateLineBreaks, 
          parseDateTooltips, parseDateArray,
          ccxGetBlob, ccxSaveAs 
} 
from "@/utils/ccx";

Vue.use(ElementUI, { globalLocale });
Vue.use(validate);

// 全局方法挂载
Vue.prototype.isEmpty = isEmpty
Vue.prototype.isArray = isArray
Vue.prototype.isNumber = isNumber
Vue.prototype.autoWrap = autoWrap
Vue.prototype.hasClass = hasClass
Vue.prototype.addClass = addClass
Vue.prototype.removeClass = removeClass
Vue.prototype.debounce = debounce
Vue.prototype.parseDateLineBreaks = parseDateLineBreaks
Vue.prototype.parseDateTooltips = parseDateTooltips
Vue.prototype.parseDateArray = parseDateArray
Vue.prototype.ccxGetBlob = ccxGetBlob
Vue.prototype.ccxSaveAs = ccxSaveAs

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import setting from './setting';
Vue.prototype.apiSettings = setting

Vue.prototype.$formattedDate = function(data,format) {
  return moment(data).format(format);
}



Vue.prototype.$to = function(name,params) {
	router.push({
    name: name,
    params: params
  })
}

Vue.prototype.$encryption = function(url, appCode) {

  getToken().then(response => {
    if(response.success === true) {
      window.open(url);
    } else {
      //link 跳转,如果验证指纹对应token失败,则去登录页面
      if(appCode === 'het2') {
        window.open(setting.LOGINURL + '?appCode=' + appCode + '&redirect=' + url);
      } else {
        window.open(setting.LOGINURL + '?appCode=' + appCode);
      }
    }
  }).catch(() => {
    //link 跳转,如果验证指纹对应token失败,则去登录页面
    if(appCode === 'het2') {
      window.open(setting.LOGINURL + '?appCode=' + appCode + '&redirect=' + url);
    } else {
      window.open(setting.LOGINURL + '?appCode=' + appCode);
    }
  })
}

Vue.prototype.$doGetProfile = function() {

  var token = sessionStorage.getItem("access_token"); 
  if((token != null) && (token != '')) {
    getProfile().then(response => {
      if(response.success === true) {
        const userData = response.data;
        this.$store.commit("setUser", userData);

        if(this.isEmpty(userData.languageCode) === false) {
          this.$setLocale(userData.languageCode);
        }
      }
    });
  }
}

Vue.prototype.$getAuthKey = function () {
  //替换原页面上验证authKey
  window.open(setting.AUTH_LINK + '?appCode=home&refresh=1', '_self');
  // router.push({
  //   path: "/list",
  //   appCode: home,
  //   refresh: 1
  // })
}

// Vue.prototype.$jumpToLogin = function () {
//   //新开页面登录
//   window.open(setting.LOGINURL + '?appCode=home');
// }

Vue.prototype.$redirectToLogin = function () {
  //替换原页面登
  window.open(setting.LOGINURL + '?appCode=home', '_self');
}

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

Vue.prototype.showLoading  = function (loadingText) {
  let instance = this.$loading({
    lock: true,
    text: loadingText,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.6)'
  });
  return instance;
}

Vue.config.productionTip = false

Vue.prototype.$initLangData = function() {

  getLanguageList().then(response => {
    if(response.success === true) {
      //TODO 组合语言包对象

      this.$i18n.setLocaleMessage({});

      response.data.forEach((langItem) => {
        const messageJSONObj = langItem.langData.reduce((prev, curr) => {
          return { ...prev, [this.$replaceSpace(curr.label)]: curr.value };
        }, {});

        if(langItem.code === 'en') {
          messageJSONObj['加载中'] = "Loading";
          messageJSONObj['暂无数据'] = "No Data!";
          messageJSONObj['全部'] = "All";
          // 消息通知相关文本
          messageJSONObj['待处理'] = "Pending";
          messageJSONObj['已处理'] = "Processed";
          messageJSONObj['暂无待处理'] = "No pending items";
          messageJSONObj['暂无已处理'] = "No processed items";
          messageJSONObj['获取消息列表'] = "Get message list";
          messageJSONObj['跳转页面'] = "Navigate to page";
          messageJSONObj['该消息暂无跳转链接'] = "No link available for this message";
          messageJSONObj['页面不存在或无访问权限'] = "Page not found or no access permission";
        }

        let langJSONObj = { 
          messages: messageJSONObj 
        };

        this.$i18n.setLocaleMessage(langItem.code, langJSONObj);
      });
      //console.log("this.$i18n: ", this.$i18n.messages);
    }
  })
}

Vue.prototype.$parseLabel = function(text) {
  if(this.$i18n.locale === 'zh') {
    //如果中文,则直接返回原字符串
    return text;
  } else {
    text = this.$replaceSpace(text);
    if(/^[\x00-\x7F]+$/.test(text)) {
      return text;
    } else {
      //如果是其它语言,则取i18n
      var realLabel = this.$t('messages.' + text);
      // console.log("$parseLabel realLabel: ", realLabel);
      if((realLabel === null) || (realLabel === undefined)) {
        return text;
      } else if(realLabel.indexOf('messages.') === 0) {
        //其它语言,返回真实值
        return realLabel;
      } else {
        return realLabel;
      }
    }
  }
}

Vue.prototype.$replaceSpace = function(text) {
  if((text != null) && (text != undefined)) {
    text = (text.indexOf(' ' !== -1)) ? text.replace(' ', '') : text;
    return text;
  }
}

Vue.prototype.$setLocale = function(curLocale) {
  //切换i18n的语言选择
  this.$i18n.locale = curLocale;
  //切换语言,保存session
  this.$store.commit("setLocale", curLocale);

  if(curLocale === 'zh') {
    globalLocale.use(langZh);
  } else if(curLocale === 'en') {
    globalLocale.use(langEn);
  }
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
